var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c('div',{staticClass:"box"},[_c('headTop'),_c('div',{staticClass:"flex"},[_c('leftNav'),(_vm.$route.path!='/')?_c('div',{staticClass:"bg"},[_c('router-view',{staticClass:"view"})],1):_c('div',{staticClass:"welc"},[_vm._v(" 欢迎使用服务分包管理系统 ")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }